import { createLucideIcon } from "lucide-react";

export const SortingZA = createLucideIcon(
    "SortingZA",
    [
        [
            "path",
            {
                d: "M17.5 20C16.7998 20 15.4915 18.0057 15 17.5",
                key: "1l4ouk",
            },
        ],
        [
            "path",
            {
                d: "M17.5 20C18.2002 20 19.5085 18.0057 20 17.5",
                key: "n4ds9m",
            },
        ],
        [
            "path",
            {
                d: "M17.5 20V4",
                key: "zqogdm",
            },
        ],
        [
            "path",
            {
                d: "M4 21L6.10557 16.3053C6.49585 15.4351 6.69098 15 7 15C7.30902 15 7.50415 15.4351 7.89443 16.3053L10 21",
                key: "1lmkdi",
            },
        ],
        [
            "path",
            {
                d: "M4 3H8.42109C9.35119 3 9.81624 3 9.94012 3.28013C10.064 3.56026 9.74755 3.89632 9.11466 4.56842L5.47691 8.43158C4.84402 9.10368 4.52757 9.43974 4.65145 9.71987C4.77533 10 5.24038 10 6.17048 10H10",
                key: "10cbrk",
            },
        ],
    ],
);
